import { getCellType } from '@/common/converter/utils/get-cell-type'
import { convertCellList } from '@/common/converter/convert-cell-list'

/**
 * convert band item
 * 구형 밴드 아이템 규격으로 변환
 */
export const convertBandItem = async (catalog) => {
  const { elementList = [] } = catalog
  return {
    cell_type: getCellType(elementList),
    celllist: await convertCellList(elementList)
  }
}
